/**
 * CS-5A — how the signed-out pages read a server refusal, in customer words only.
 *
 * The server tags link refusals with a machine code (`LINK_EXPIRED`, `LINK_USED`, `LINK_INVALID`) so a page
 * can switch to the right state without matching on wording. Nothing technical is ever shown to a customer.
 */

/** "expired" | "used" | "invalid" for a link refusal, otherwise null. */
export function linkError(err) {
  const code = err?.response?.data?.code;
  if (code === "LINK_EXPIRED") return "expired";
  if (code === "LINK_USED") return "used";
  if (code === "LINK_INVALID") return "invalid";
  return null;
}

/** The one sign-in failure message (R-6), whatever the reason. */
export const LOGIN_REFUSED = "The login details could not be verified.";

/** CS6 Phase 8 follow-up (owner ruling RB-2): a sign-in whose account is not a customer account. */
export const NOT_CUSTOMER_ACCOUNT = "This sign-in is for VVR customer accounts.";

/** A customer-safe message for a sign-in attempt that did not succeed. */
export function loginFailureMessage(err) {
  const status = err?.response?.status;
  if (!err?.response) return "We could not reach VVR. Please check your connection and try again.";
  if (err.response.data?.code === "NOT_CUSTOMER_ACCOUNT") return NOT_CUSTOMER_ACCOUNT;
  if (status === 429) return "Too many attempts. Please wait a few minutes and try again.";
  if (status >= 500) return "Something went wrong on our side. Please try again in a moment.";
  return LOGIN_REFUSED;
}

/** Generic: a network problem vs. a server message that is safe to show. */
export function friendlyError(err, fallback) {
  if (!err?.response) return "We could not reach VVR. Please check your connection and try again.";
  if (err.response.status >= 500) return fallback;
  return err.response.data?.message || fallback;
}
